/**
 * Size Preview Add to Cart
 * Makes the size availability preview buttons add items directly to cart
 */
(function () {
  'use strict';

  function initSizePreviewATC() {
    document.addEventListener('click', function (e) {
      const sizeButton = e.target.closest('.size-preview-button.available');

      if (!sizeButton) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = sizeButton.getAttribute('data-toggle');

      if (!variantId) return;

      const loadingDiv = sizeButton.querySelector('.size-loading');
      if (loadingDiv) {
        loadingDiv.classList.add('show');
      }
      sizeButton.style.pointerEvents = 'none';

      addToCart(variantId, sizeButton, loadingDiv);
    });
  }

  function getSectionsToRender() {
    return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ];
  }

  function addToCart(variantId, button, loadingDiv) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', getSectionsToRender().map((section) => section.section));
    formData.append('sections_url', window.location.pathname);

    fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Add to cart error:', response.description);
          return;
        }

        if (response.sections) {
          renderContents(response);
        }

        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      })
      .catch((error) => {
        console.error('Add to cart error:', error);
      })
      .finally(() => {
        if (loadingDiv) {
          loadingDiv.classList.remove('show');
        }
        button.style.pointerEvents = '';
      });
  }

  function renderContents(parsedState) {
    getSectionsToRender().forEach((section) => {
      if (!document.getElementById(section.id)) {
        return;
      }
      if (!parsedState.sections[section.section]) {
        return;
      }
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    const cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer && typeof OverlayManager !== 'undefined') {
      OverlayManager.open(cartDrawer);
      dispatchCustomEvent('cart-drawer:open');
    }
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  function dispatchCustomEvent(eventName, data = {}) {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      detail: data
    });
    document.dispatchEvent(event);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizePreviewATC);
  } else {
    initSizePreviewATC();
  }
})();